import { render, staticRenderFns } from "./SearchBoxSimple.vue?vue&type=template&id=62fdfbde&scoped=true&lang=html"
import script from "./SearchBoxSimple.vue?vue&type=script&lang=js"
export * from "./SearchBoxSimple.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxSimple.vue?vue&type=style&index=0&id=62fdfbde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdfbde",
  null
  
)

export default component.exports